import dayjs from "dayjs";
import UnderlinedText from "./underlined_text";
import { Grid } from "@mui/material";
import { fieldHeader } from "../../../../components/fields/field_header";

const ViewLicenseInformation = ({ data }: any) => {
  return (
    <>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Type of License Applying For", true)}</Grid>
        <UnderlinedText text={data.licenseType} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Date of Application", true)}</Grid>
        <UnderlinedText
          text={dayjs(data.applicationDate).format("MM-DD-YYYY")}
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <Grid item>{fieldHeader("Application Submitted by", true)}</Grid>
        <UnderlinedText text={data.submittedBy} />
      </Grid>
      <Grid item xs={12} md={data.storeFormat === "Other" ? 6 : 12}>
        <Grid item>{fieldHeader("Store Format", true)}</Grid>
        <UnderlinedText text={data.storeFormat} />
      </Grid>
      {data.storeFormat === "Other" && (
        <Grid item xs={12} md={6}>
          <Grid item>{fieldHeader("Other Store Format (explain)", false)}</Grid>
          <UnderlinedText text={data.otherStoreFormat} />
        </Grid>
      )}
      <Grid item xs={12} md={data.distributionCenter === "Other" ? 6 : 12}>
        <Grid item>
          {fieldHeader("Name of Distribution Center or Wholesaler", true)}
        </Grid>
        <UnderlinedText text={data.distributionCenter} />
      </Grid>
      {data.distributionCenter === "Other" && (
        <Grid item xs={12} md={6}>
          <Grid item>
            {fieldHeader("Other Distribution Center or Wholesaler", false)}
          </Grid>
          <UnderlinedText text={data.otherDistributionCenter} />
        </Grid>
      )}
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("How many stores do you own?", false)}</Grid>
        <UnderlinedText text={data.numStoresOwned} />
      </Grid>
      <Grid item xs={12} md={8}>
        <Grid item>
          {fieldHeader(
            "How many stores are you applying to become a Licensed IGA?",
            false
          )}
        </Grid>
        <UnderlinedText text={data.numStoreApplied} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Wholesaler Phone Contact", false)}</Grid>
        <UnderlinedText text={data.wholesalerContact} />
      </Grid>
      <Grid item xs={12} md={8}>
        <Grid item>{fieldHeader("Wholesaler Email Contact", false)}</Grid>
        <UnderlinedText text={data.wholesalerEmail} />
      </Grid>
    </>
  );
};

export default ViewLicenseInformation;
